// src/UserModals/DeleteModal.jsx
import React, { useEffect, useState } from "react";
import ConfirmModal from "../CommonComponents/ConfirmModal";
import UserStateModal from "./UserStateModal";
import axios from "../../../utils/cmsAxios";

const API = (process.env.REACT_APP_FASTAPI_ADS_URL || "").replace(/\/+$/,"");

export default function DeleteModal({ open, onClose, target, getUserDetail, getSubLabel, onDone }) {
  const [detail, setDetail] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open || !target?.user_id) return;
    let off = false;
    (async () => {
      try {
        const data = await getUserDetail(target.user_id);
        if (!off) setDetail(data || null);
      } catch { if (!off) setDetail(null); }
    })();
    return () => { off = true; };
  }, [open, target, getUserDetail]);

  const submit = async () => {
    setSaving(true);
    try {
      await axios.delete(`${API}/ads/user/${target.user_id}`);
      onDone?.(); onClose();
    } catch { alert("삭제 실패"); }
    finally { setSaving(false); }
  };

  return (
    <ConfirmModal
      open={open}
      title={<span className="text-m font-bold">회원 삭제</span>}
      onClose={() => !saving && onClose()}
      closeOnOverlay={false}
      message={
        <div className="space-y-3">
          <UserStateModal
            detail={detail}
            fallbackName={target?.nickname}
            subStatusLabel={getSubLabel(detail?.subscription_type)}
          />
          <hr className="border-neutral-200" />
          <p className="text-m font-semibold">회원의 정보를 삭제 하시겠습니까?</p>
        </div>
      }
      buttons={[
        { label: saving ? "삭제 중..." : "회원 삭제", intent:"primary", autoFocus:true, onClick: submit, disabled: saving },
        { label: "취소", onClick: () => !saving && onClose() },
      ]}
    />
  );
}
